export const routeProps = {
  path: '/orders/:orderId?/:action?',
  exact: true,
};

export default (orderId, action) => `/orders/${orderId}${action ? `/${action}` : ''}`;
